import React, { useState, useEffect } from "react";
import { OuterContainer } from "../../EventCreation/styles";
import ActionBar from "../../common/ActionBar";
import styled from "styled-components";
import theme from "../../../assets/theme";
import {
  Paper,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Formik } from "formik";
import FormField, { ButtonContainer, FormControl } from "../FormInputs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { SecondaryCTAButton, PrimaryCTAButton } from "../../common/Buttons";
import { FormLabel } from "../../common/FormInputs";
import { AddCircleOutline } from "@material-ui/icons";
import { useSnackbar } from "notistack";
import useLoader from "../../../hooks/useLoader";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";
import moment from "moment";
import { navigate } from "@reach/router";
import _ from "lodash";

var icons = ReactQuill.Quill.import("ui/icons");
icons[
  "bold"
] = `<img src=${require("../../../assets/images/editor/bold.svg")} aria-hidden="true" />`;
icons[
  "italic"
] = `<img src=${require("../../../assets/images/editor/italics.svg")} aria-hidden="true" />`;
icons[
  "underline"
] = `<img src=${require("../../../assets/images/editor/underline.svg")} aria-hidden="true" />`;
icons[
  "blockquote"
] = `<img src=${require("../../../assets/images/editor/blockQuote.svg")} aria-hidden="true" />`;
icons["align"][
  ""
] = `<img src=${require("../../../assets/images/editor/leftAlign.svg")} aria-hidden="true" />`;
icons["align"][
  "center"
] = `<img src=${require("../../../assets/images/editor/centerAlign.svg")} aria-hidden="true" />`;
icons["align"][
  "right"
] = `<img src=${require("../../../assets/images/editor/rightAlign.svg")} aria-hidden="true" />`;

const modules = {
  toolbar: [
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      "bold",
      "italic",
      "underline",
      "blockquote",
      "link",
      "image",
    ],
  ],
};

const Speakers = (id) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const [commentItems, setCommentItems] = useState([]);
  const [clickedButton, setClickedButton] = useState("");

  const initialState = {
    speakerName: "",
    companyName: "",
    designation: "",
    experience: "",
    scheduleDate: "",
    scheduleTime: "",
    uploadPicture: "",
    pictureTreatment: "",
    aboutSpeaker: "",
  };

  const inputs = [
    {
      name: "speakerName",
      label: "Speaker Name",
      type: "text",
      placeholder: "Enter speaker name",
    },
    {
      name: "companyName",
      label: "Company Name",
      type: "text",
      placeholder: "Enter company name",
    },
    {
      name: "designation",
      label: "Designation",
      type: "text",
      placeholder: "Enter designation",
    },
    {
      name: "sectionTitle",
      label: "Section Title",
      type: "text",
      placeholder: "Enter section title",
    },
    {
      name: "experience",
      label: "Experience",
      type: "text",
      placeholder: "Enter experience",
    },
    { name: "scheduleDate", label: "Schedule Date", type: "date" },
    { name: "scheduleTime", label: "Schedule Time", type: "time" },
    {
      name: "uploadPicture",
      label: "Upload Picture",
      type: "upload",
      accept: "image/*",
    },
    {
      name: "pictureTreatment",
      label: "Picture Treatment",
      type: "radio",
      menuItems: [
        { name: "circular", value: "circular", label: "Circular" },
        { name: "square", value: "square", label: "Square" },
      ],
    },
  ];

  const custom_buttons = [
    {
      label: "SAVE",
      color: "default",
      primary: true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "speakers");
        setCommentItems(response);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    if (id?.id) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id?.id, "speakers");
      setCommentItems(response);
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description theme settings submit function
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        speakerSettings: values.items.map((arr) => ({
          ...arr,
          scheduleDate: moment(arr.scheduleDate).format("DD/MM/YYYY"),
          scheduleTime: moment(arr?.scheduleTime).format("HH:mm"),
        })),
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        navigate(`/dashboard/eventmanager/resources/${id?.id}`);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const addCommentItems = (values, setFieldValue) => {
    const new_items = [
      ...values?.items,
      {
        speakerName: "",
        companyName: "",
        designation: "",
        experience: "",
        scheduleDate: "",
        scheduleTime: "",
        uploadPicture: "",
        pictureTreatment: "",
        aboutSpeaker: "",
      },
    ];
    setFieldValue("items", new_items);
  };

  const deleteCommentItems = (index, values, setFieldValue) => {
    const new_items = [...values?.items].filter((ci, idx) => idx !== index);
    setFieldValue("items", new_items);
  };

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "theme_settings":
        id?.id
          ? navigate(`/dashboard/eventmanager/theme-settings/${id?.id}`)
          : navigate(`/dashboard/eventmanager/theme-settings`);
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "Theme Settings",
                "Speaker Settings",
                commentItems?.eventName
                  ? `${commentItems?.eventName} (${commentItems?.eventDate})`
                  : "",
              ]
            : ["Event Manager", "Theme Settings", "Speaker Settings"]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            items: commentItems?.speakerSettings?.length
              ? commentItems?.speakerSettings?.map((item) => ({
                  speakerName: item?.speakerName,
                  companyName: item?.companyName,
                  designation: item?.designation,
                  sectionTitle: item?.sectionTitle,
                  experience: item?.experience,
                  scheduleDate:
                    moment(item?.scheduleDate, "DD/MM/YYYY")
                      .set({
                        hour: 7,
                        minute: 29,
                        second: 0,
                        millisecond: 0,
                      })
                      .toISOString() || "",
                  scheduleTime:
                    moment(item?.scheduleTime, "HH:mm:ss").toISOString() || "",
                  uploadPicture: item?.uploadPicture,
                  pictureTreatment: item?.pictureTreatment,
                  aboutSpeaker: item?.aboutSpeaker,
                }))
              : [initialState] || [initialState],
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
          validationSchema={""}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
            handleSubmit,
            resetForm,
          }) => (
            <FormContainer>
              <Container>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Speaker Settings</Heading>
                  {values?.items.map((arr, index) => (
                    <Paper
                      elevation={3}
                      style={{
                        padding: 16,
                        border: "1px solid #e1e3ee",
                        marginTop: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={3}
                        style={{ padding: 16 }}
                      >
                        {inputs.map((item, idx) => (
                          <Grid
                            item
                            xs={isBigScreen ? 4 : 12}
                            key={item.name}
                            style={styles.gridItem}
                          >
                            <FormField
                              {...{
                                item,
                                handleChange,
                                values,
                                setFieldValue,
                                errors,
                              }}
                              accept={item.accept}
                              value={arr[item.name]}
                              name={`items[${index}].${item.name}`}
                              touched={`items[${index}].${item.name}`}
                              direction={"row"}
                            />
                          </Grid>
                        ))}
                      </Grid>
                      <Grid>
                        <FormLabel
                          style={{
                            fontFamily: theme.fonts.primaryFontSemiBold,
                            color: "#A6AEBF",
                            marginLeft: "32px",
                          }}
                        >
                          About Speaker
                        </FormLabel>
                        <CommentContainer>
                          <EditorContainer>
                            <ReactQuill
                              value={arr.aboutSpeaker}
                              name={`items[${index}].aboutSpeaker`}
                              onChange={(text) =>
                                setFieldValue(
                                  `items[${index}].aboutSpeaker`,
                                  text,
                                )
                              }
                              modules={modules}
                              placeholder="Type here…"
                            />
                          </EditorContainer>
                        </CommentContainer>
                      </Grid>
                      {values.items.length > 1 && (
                        <Grid
                          item
                          xs={12}
                          style={{
                            textAlign: "left",
                            marginTop: "20px",
                          }}
                        >
                          <PrimaryCTAButton
                            style={{ width: "auto", marginLeft: 8 }}
                            onClick={() =>
                              deleteCommentItems(index, values, setFieldValue)
                            }
                          >
                            Delete
                          </PrimaryCTAButton>
                        </Grid>
                      )}
                    </Paper>
                  ))}
                  <ButtonWrapper>
                    <SecondaryCTAButton
                      onClick={() => addCommentItems(values, setFieldValue)}
                      style={{ paddingLeft: 0 }}
                    >
                      <AddCircleOutline
                        style={{ marginRight: "10px", marginLeft: "5px" }}
                      />{" "}
                      Add More Speakers
                    </SecondaryCTAButton>
                  </ButtonWrapper>
                  <FormControl>
                    <ButtonContainer>
                      {custom_buttons.map((button) => (
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            handleButtonClick(button, resetForm, handleSubmit)
                          }
                        >
                          {button.label}
                        </PrimaryCTAButton>
                      ))}
                    </ButtonContainer>
                  </FormControl>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default Speakers;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const EditorContainer = styled.div`
  width: 95%;
  & .rdw-editor-wrapper,
  .ql-editor,
  .ql-container {
    background-color: #f9f9f9;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border: none;
    font-family: ${theme.fonts.primaryFontRegular};
  }
  .ql-editor {
    padding: 16px 16px;
    height: 180px;
  }
  & .rdw-editor-toolbar,
  .ql-toolbar {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: #f4f6ff;
    border: none;
    & button {
      padding: 0;
    }
  }
  & .rdw-option-wrapper {
    background-color: transparent;
    border: 1px solid transparent;
    &:hover {
      box-shadow: none;
    }
  }
  & .ql-active {
    box-shadow: none;
    border: 1px solid rgb(200, 210, 220) !important;
  }
  & .rdw-editor-main {
    padding: 0 17px 10px;
    font-family: ${theme.fonts.primaryFontRegular};
  }
  & .public-DraftEditorPlaceholder-root,
  & .quill > .ql-container > .ql-editor.ql-blank::before {
    font-family: ${theme.fonts.primaryFontSemiBold};
    font-size: 14px;
    color: #acb1c2;
    font-style: normal;
  }
  & .blockquote .rdw-option-wrapper {
    content: "";
  }
  & .ql-toolbar.ql-snow {
    padding: 12px 12px 16px;
    .ql-formats button {
      margin-right: 60px;
    }
    .ql-align {
      outline: none;
    }
  }
`;

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 7px;
  }
`;

export const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 125px;
`;

const CommentContainer = styled.div`
  width: 95%;
  display: flex;
  margin: 15px;
`;
